import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.99805 6.28332L2.00195 16.5833C2.00195 17.7615 2.95708 18.7167 4.13529 18.7167H15.8686C17.0468 18.7167 18.002 17.7615 18.002 16.5833V8.04999C18.002 7.06815 17.206 6.27221 16.2242 6.27221H14.002M1.99805 6.28332C1.9987 6.08363 14.002 1.28333 14.002 1.28333M1.99805 6.28332C2.00039 6.27667 2.00667 6.27221 2.01373 6.27221H14.002M13.7492 12.3027L13.7353 12.3167M14.002 1.28333V5.78332V6.27221M14.002 1.28333V6.27221",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }